import React from 'react'

type ChatBubblesIconProps = {
  width?: number | string
  height?: number | string
  className?: string
  color?: string
}

// Lucide's messages-square on its 24 grid; a 1.44 stroke draws at 1.2 when sized to 20.
export const ChatBubblesIcon = ({
  width = 20,
  height = 20,
  className,
  color = 'currentColor',
}: ChatBubblesIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    stroke={color}
    strokeWidth={1.44}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z" />
    <path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1" />
  </svg>
)
